// extracted by mini-css-extract-plugin
module.exports = {"nameText":"statisticsOfChangesInChainWarehouses_nameText__qFmga","productText":"statisticsOfChangesInChainWarehouses_productText__20ybZ"};